<template>
    <ContainerWithMenu>
        <div class="page-content">
            <h1 class="h2">{{$t('views.marketing.title')}}</h1>
            <p class="margin-bottom-40">{{$t('views.marketing.desc')}}</p>
            <div class="row">
                <div class="col-xs-12 col-sm-4">
                    <router-link to="/marketing/calendar">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <i class="las la-calendar margin-bottom-5" style="font-size:40px;"></i>
                                <h4>{{$t('views.marketing.calendar_title')}}</h4>
                                {{$t('views.marketing.calendar_desc')}}
                            </div>
                        </div>
                    </router-link>
                </div>
                <div class="col-xs-12 col-sm-4 hide">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <i class="las la-percentage margin-bottom-5" style="font-size:40px;"></i>
                            <h4>{{$t('views.marketing.coupons_title')}}</h4>
                            {{$t('views.marketing.coupons_desc')}}
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4" v-if="hasEnabledShowcaseFeature">
                    <router-link to="/marketing/showcases">
                        <div class="panel panel-default">
                            <div class="panel-body">
                                <i class="las la-tv margin-bottom-5" style="font-size:40px;"></i>
                                <h4>{{$t('views.marketing.showcases_title')}}</h4>
                                {{$t('views.marketing.showcases_desc')}}
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import i18n from "../i18n";
    import {StorageHelper} from "../common/storageHelper";

    export default {
        title: i18n.t('views.marketing.title'),
        name: "Marketing",
        components: { ContainerWithMenu, },

        computed: {
            hasEnabledShowcaseFeature: function () {
                return StorageHelper.getUser().company.feature_showcase || false
            }
        }
    };
</script>